import { useState, useLayoutEffect } from 'react';
import debounce from 'lodash.debounce';

function getSize(el: any) {
  if (!el) {
    return {};
  }

  return {
    width: el.offsetWidth,
    height: el.offsetHeight,
  };
}

export function useComponentSize(ref: any) {
  let [ComponentSize, setComponentSize] = useState(getSize(ref.current));

  function handleResize() {
    if (ref && ref.current) {
      setComponentSize(getSize(ref.current));
    }
  }

  useLayoutEffect(() => {
    handleResize();
    window.addEventListener('resize', debounce(handleResize, 200));

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return ComponentSize;
}
